import { useLocation, Link } from "react-router-dom";
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar.tsx";
import { Collapsible } from "@/components/ui/collapsible.tsx";
import { getMenuList } from "@/lib/menu-config.ts";
import { CollapseMenuItem } from "@/components/sidebar/collapse-menu.tsx";

export const Menu = () => {
  const menuList = getMenuList();
  const location = useLocation();

  const isPathActive = (menuPath: string, currentPath: string) => {
    if (menuPath === "/") {
      return currentPath === "/"
    }
    return currentPath.startsWith(menuPath);
  }

  return (
    <SidebarMenu>
      <Collapsible className="group/collapsible">
        {menuList.map(({ label, path, icon: IconComponent, active, children }) => {
          const itemKey = path || label;
          const hasChildren = Array.isArray(children) && children.length > 0;
          const isActive = active !== undefined
            ? active
            : isPathActive(path, location.pathname);

          if (!hasChildren) {
            return (
              <SidebarMenuItem key={itemKey}>
                <SidebarMenuButton asChild variant={isActive ? "active" : "default"}>
                  <Link to={path} className="flex w-full h-full items-center justify-between gap-2">
                    <div className="flex items-center gap-2 text-base">
                      {IconComponent && (
                        <IconComponent
                          className="w-6 h-6 text-current"
                          aria-hidden="true"
                        />
                      )}
                      <p className="group-data-[collapsible=icon]:hidden">{label}</p>
                    </div>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            );
          }

          return (
            <SidebarMenuItem key={itemKey}>
              <CollapseMenuItem
                icon={IconComponent}
                label={label}
                children={children ?? []}
                active={isActive}
                path={path}
                id={itemKey}
              />
            </SidebarMenuItem>
          );
        })}
      </Collapsible>
    </SidebarMenu>
  );
}